// extracted by mini-css-extract-plugin
export default {"headerLinkItem":"link-headerLinkItem--062a3","headerLink":"link-headerLink--f052a","headerLink__prenav":"link-headerLink__prenav--6627d"};